import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20388 19911"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970275870864">
        <path
          d="m4690 9459 4332-4729 4331 4729H4690zm6319 8942H7034v-7949h3975v7949zM9379 3656c-198-198-556-198-715 1L3219 9618c-119 159-159 358-79 517 79 159 238 278 437 278h2464v8465c0 278 238 517 517 517h4968c277 0 516-239 516-517v-8426h2424c199 0 358-119 437-277 80-159 40-398-79-517L9379 3656z"
          className="fil0"
        />
        <path
          d="m3935 7790 5087-5564 5087 5564c198 199 516 199 715 39 199-198 199-516 40-715L9419 1153c-199-199-556-199-715 0L3259 7114c-199 199-159 517 39 715 120 160 438 160 637-39zM19911 2981c263 0 477 214 477 477s-214 477-477 477-477-214-477-477 214-477 477-477zM17407 7909c286 0 517 232 517 517s-231 517-517 517c-285 0-517-232-517-517 0-286 232-517 517-517zM16930 17845c286 0 517 231 517 516 0 286-231 517-517 517-285 0-516-231-516-517 0-285 231-516 516-516zM2504 13870c285 0 516 232 516 517s-231 517-516 517c-286 0-517-232-517-517s231-516 517-517zM517 3935c285 0 516 231 516 516 0 286-231 517-516 517-286 0-517-231-517-517 0-285 231-516 517-516zM4491 994c285 0 517 231 517 517 0 285-232 516-517 516s-517-231-517-516c0-286 231-517 517-517zM2742 18878c-397 0-755-318-755-755s318-755 755-755c398 0 755 318 755 755s-318 755-755 755zm0-2464c-954 0-1748 795-1748 1749 0 953 794 1748 1748 1748s1749-795 1749-1748c0-954-755-1749-1749-1749zM17646 14904c-676 0-1232-557-1232-1232 0-676 556-1232 1232-1232 675 0 1231 556 1231 1232 0 675-516 1232-1231 1232zm0-3458c-1232 0-2226 994-2226 2226s994 2226 2226 2226c1231 0 2225-994 2225-2226s-954-2226-2225-2226zM15937 1511c0-279 238-517 516-517s517 238 517 517c0 278-239 516-517 516s-516-278-516-516zm1987 0c0-835-676-1511-1510-1511-835 0-1511 676-1511 1511 0 834 676 1510 1511 1510 834 0 1510-716 1510-1510z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
